const items = [
  'Football · Ligue 1',
  'Champions League',
  'NBA Basketball',
  'Tennis ATP',
  'Rugby TOP 14',
  'Formule 1',
  'Boxe & MMA',
  'eSport',
];

export default function Ticker() {
  const doubled = [...items, ...items];
  return (
    <div className="ticker-wrap">
      <div className="ticker-inner">
        {doubled.map((item, i) => (
          <div className="ticker-item" key={i}>
            <span className="ticker-dot"></span> {item}
          </div>
        ))}
      </div>
    </div>
  );
}
